export default __webpack_public_path__ + "static/background-3bf08545a8bd373a398cb7018f2cd598.gif";